(function () {
    'use strict';

    angular
        .module('atheer.content')
        .controller('ContentMetaDataController', ContentMetaDataController)

    /* @ngInject */
    function ContentMetaDataController($state, $scope, $window, $mdSidenav, MetaData, AlertService, $mdDialog, $filter, id, ToastService, Feature) {
        var vm = this;
        var MAX_OPTIONAL_VISIBLE_COLUMNS = 3;
        var SUBTITLE_MAX_COLUMNS = 4;
        var ALWAYS_VISIBLE_FIELD_NAMES = ['title'];

        vm.loadAll = loadAll;
        vm.updateObject = false;
        vm.metaDataObject;
        vm.selectedFieldGroup;
        vm.loadingData = true;
        vm.maxOptionalVisibleColumns = MAX_OPTIONAL_VISIBLE_COLUMNS;
        vm.subtitleMaxColumns = SUBTITLE_MAX_COLUMNS;
        vm.extendedFieldsEnabled = Feature.isActive('feature_content_extended_fields');

        vm.loadAll();

        function loadAll() {
            MetaData.get({
                id: id,
                is_name: true,
                add_default_properties: true
            }, function (result) {
                vm.metaDataObject = result;
                normalizeColumnVisibility(vm.metaDataObject);
                vm.updateObject = false;
                if (vm.metaDataObject.field_groups && vm.metaDataObject.field_groups.length > 0) {
                    vm.selectedFieldGroup = vm.metaDataObject.field_groups[0];
                }
                vm.loadingData = false;
            });
        };

        function normalizeColumnVisibility(metaDataObject) {
            if (!metaDataObject || !metaDataObject.field_groups) {
                return;
            }
            angular.forEach(metaDataObject.field_groups, function (group) {
                angular.forEach(group.fields || [], function (field) {
                    if (ALWAYS_VISIBLE_FIELD_NAMES.indexOf(field.name) !== -1) {
                        field.column_visible = true;
                    } else {
                        field.column_visible = !!field.column_visible;
                    }
                });
            });
        }

        function countOptionalVisibleColumns() {
            var count = 0;
            angular.forEach(vm.metaDataObject.field_groups || [], function (group) {
                angular.forEach(group.fields || [], function (field) {
                    if (field.column_visible && ALWAYS_VISIBLE_FIELD_NAMES.indexOf(field.name) === -1) {
                        count++;
                    }
                });
            });
            return count;
        }

        vm.isColumnVisibilityLockedOn = function (field) {
            return ALWAYS_VISIBLE_FIELD_NAMES.indexOf(field.name) !== -1;
        };

        vm.onColumnVisibilityChange = function (field) {
            if (vm.isColumnVisibilityLockedOn(field)) {
                field.column_visible = true;
                return;
            }
            if (field.column_visible && countOptionalVisibleColumns() > MAX_OPTIONAL_VISIBLE_COLUMNS) {
                field.column_visible = false;
                ToastService.displayToast(
                    $filter('translate')('atheer.contentFields.maxVisibleColumns', {
                        max: MAX_OPTIONAL_VISIBLE_COLUMNS
                    }),
                    3000
                );
                return;
            }
            updateMetaData('atheer.contentFields.fieldUpdated', vm.selectedFieldGroup, {
                silent: true,
                revertField: field,
                previousVisible: !field.column_visible
            });
        };

        vm.selectFieldGroup = function (fieldGroup) {
            vm.updateObject = false;
            angular.forEach(vm.metaDataObject.field_groups, function (tempFieldGroup) {
                if (tempFieldGroup.name == fieldGroup.name) {
                    vm.selectedFieldGroup = tempFieldGroup;
                }
            });
        };

        vm.addFieldGroup = function (fieldGroup) {
            $mdDialog.show({
                templateUrl: 'modules/system/metadata/field-group-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: 'FieldGroupDialogController',
                controllerAs: "vm",
                size: 'lg',
                locals: {
                    fieldGroup: {
                        name: null,
                        label: null,
                        description: null,
                        is_many: true,
                        fields: null,
                    },
                    isAdd: true
                }
            }).then(function (fieldGroup) {
                if (!vm.metaDataObject.field_groups) {
                    vm.metaDataObject.field_groups = [];
                }
                vm.metaDataObject.field_groups.push(fieldGroup);
                vm.updateObject = false;
                vm.selectedFieldGroup = fieldGroup;
                updateMetaData('atheer.contentFields.fieldGroupAdded', fieldGroup);
            });
        }

        vm.editFieldGroup = function (fieldGroup, index) {
            $mdDialog.show({
                templateUrl: 'modules/system/metadata/field-group-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: 'FieldGroupDialogController',
                controllerAs: "vm",
                size: 'lg',
                locals: {
                    fieldGroup: angular.copy(fieldGroup),
                    isAdd: false
                }
            }).then(function (fieldGroup) {
                vm.metaDataObject.field_groups[index] = fieldGroup;
                updateMetaData('atheer.contentFields.fieldGroupUpdated');
            });
        }

        vm.deleteFieldGroup = function (fieldGroup, index) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.contentFields.deleteFieldGroup'))
                .ariaLabel($filter('translate')('atheer.contentFields.deleteFieldGroup'))
                .ok($filter('translate')('entity.action.delete'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function () {
                vm.metaDataObject.field_groups.splice(index, 1);
                updateMetaData('atheer.contentFields.fieldGroupDeleted', vm.metaDataObject.field_groups[index == 0 ? 0 : index - 1]);
            });
        }

        vm.addField = function () {
            $mdDialog.show({
                templateUrl: 'modules/system/metadata/field-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: 'FieldDialogController',
                controllerAs: "vm",
                size: 'lg',
                locals: {
                    field: {
                        name: null,
                        description: null,
                        label: null,
                        data_type: 'STRING',
                        type: 'FLEX',
                        required: false,
                        enabled: true,
                        search_enabled: true,
                        column_visible: false
                    },
                    isAdd: true
                }
            }).then(function (field) {
                vm.updateObject = false;
                if (!vm.selectedFieldGroup.fields) {
                    vm.selectedFieldGroup.fields = [];
                };
                field.column_visible = !!field.column_visible;
                vm.selectedFieldGroup.fields.push(field);
                updateMetaData('atheer.contentFields.fieldAdded');
            });
        }

        vm.editField = function (field, index) {
            $mdDialog.show({
                templateUrl: 'modules/system/metadata/field-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: 'FieldDialogController',
                controllerAs: "vm",
                size: 'lg',
                locals: {
                    field: angular.copy(field),
                    isAdd: false
                }
            }).then(function (field) {
                vm.updateObject = false;
                if (typeof field.column_visible === 'undefined') {
                    field.column_visible = !!vm.selectedFieldGroup.fields[index].column_visible;
                }
                vm.selectedFieldGroup.fields[index] = field;
                updateMetaData('atheer.contentFields.fieldUpdated');
            });
        }

        vm.copyField = function (field, index) {
            var newField = angular.copy(field);
            newField.name = "Copy of " + newField.name;
            newField.column_visible = false;
            vm.updateObject = false;
            vm.selectedFieldGroup.fields.push(newField);
            updateMetaData('atheer.contentFields.fieldCopied');
        }

        vm.deleteField = function (field, index) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.contentFields.deleteFieldGroup'))
                .ariaLabel($filter('translate')('atheer.contentFields.deleteFieldGroup'))
                .ok($filter('translate')('entity.action.delete'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function () {
                vm.updateObject = false;
                vm.selectedFieldGroup.fields.splice(index, 1);
                updateMetaData('atheer.contentFields.fieldDeleted');
            });
        }

        vm.back = function () {
            $window.history.back();
        };

        function updateMetaData(successMessage, fieldGroupToSelect, options) {
            options = options || {};
            var silent = !!options.silent;

            if (!silent) {
                vm.loadingData = true;
            }

            MetaData.update({
                id: id
            }, vm.metaDataObject, onSaveSuccess, onSaveError);

            function onSaveSuccess(result) {
                var selectedGroup = fieldGroupToSelect || vm.selectedFieldGroup;

                vm.metaDataObject = result;
                normalizeColumnVisibility(vm.metaDataObject);

                if (selectedGroup != null) {
                    vm.selectFieldGroup(selectedGroup);
                } else if (vm.metaDataObject.field_groups && vm.metaDataObject.field_groups.length) {
                    vm.selectedFieldGroup = vm.metaDataObject.field_groups[0];
                }

                ToastService.displayToast($filter('triTranslate')(successMessage), 3000);
                if (!silent) {
                    vm.loadingData = false;
                }
            }

            function onSaveError() {
                if (options.revertField) {
                    options.revertField.column_visible = options.previousVisible;
                }
                if (!silent) {
                    vm.loadingData = false;
                }
            }
        }
    }
})();
